/* libs/shared/src/lib/ui/back-btn/back-btn.component.scss */
.back-btn {
  cursor: pointer;
  font-size: 16px;
  position: relative;
  top: -4px;
  margin-right: 5px;
}
/*# sourceMappingURL=back-btn.component.css.map */
